export default __webpack_public_path__ + "locales/fr/DataReassignmentDialog.json?hash=d9f797ce0a5ab3f491df007f5a5e06cb";